import React from 'react';
import PropTypes from 'prop-types';
import deepEqual from 'react-fast-compare';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent/DialogContent';
import Grid from '@material-ui/core/Grid/Grid';
import classNames from 'classnames';
import Close from '@material-ui/icons/Close';
import { connect } from 'react-redux';
import DialogActions from '@material-ui/core/DialogActions/DialogActions';
import { Field, change, initialize, reduxForm } from 'redux-form';
import axios from 'axios';
import cloneDeep from 'clone-deep';

import {
    apiCatchBlockFunction,
    isArrayValidAndNotEmpty,
    extractTextFromDoubleQuotes,
    getIndexFromFieldName, getJsonPath,
    reprocessJsonBySlicing,
} from '../../constants/CommonUtil';
import { ACTION_HANDLERS, extractAndSetValues } from './AddStockActionHandlers';
import ReduxFormMaterialTable from '../FormFieldComponents/ReduxFormMaterialTable/ReduxFormMaterialTable';
import ReduxFormReactSelectMaterial from '../ReduxFormReactSelectMaterial';
import API from '../../constants/api';
import OutlinedTextField from '../OutlinedTextField';
import { mapAddStockDtoToUiObject, mapAddStockFromUiObject, UI_OBJECT } from '../../mapper/AddStockMapper';
import { createAddStockRequest } from '../../redux/modules/addStock/addStock-actions';
import { required } from '../../constants/FormValidations';
import ActionButton from '../ActionButton/ActionButton';
import {
    clearStockMoveByPurchaseOrderState,
    fetchStockMovesRequest,
} from '../../redux/modules/stockMove/stockMove-actions';
import SideLabelReadOnlyText from '../FormFieldComponents/SideLabelReadOnlyText/SideLabelReadOnlyText';
import { getDateInYYYYMMDDFormat } from '../../constants/DateUtil';
import { PAGE, SIZE } from '../../constants/constants';
import DrugBarcodeEntry from './InternalMovesDialog/DrugBarcodeEntry';
import { getIndexToAdd, PRODUCT_CODE_FIELD } from './InternalMovesDialog/InternalMovesUtil';
import DateInput from '../FormFieldComponents/DateInput/DateInput';
import dialogComponentStyles from '../DialogComponent/DialogComponentStyles';
import GtinMapper from '../GtinComponent/GtinMapper';
import { errorMessage } from '../../redux/modules/message/message-actions';
import { getStringFromObject } from '../../constants/lodashUtils';
import { NumberOf } from '../../constants/numberUtils';
import { isObjectValidAndNotEmpty } from '../../constants/nullCheckUtils';

const formName = 'addStockForm';

class AddStockDialog extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            schema: null,
            page: PAGE,
            size: SIZE,
            createNewGtin: false,
            index: 0,
        };
    }

    componentDidMount() {
        const { appConfiguration } = this.props;
        const jsonApi = getJsonPath('/StockManagement/AddStock.json');
        this.getAllBatchesForPurchaseOrderInternal();
        fetch(jsonApi)
            .then(resp => resp.json())
            .then((json) => {
                this.setState({
                    schema: reprocessJsonBySlicing(appConfiguration, json),
                });
            })
            .catch((error) => {
                console.error(`There has been a problem with your fetch operation:${error.message}`);
            });
    }

    componentWillReceiveProps(nextProps) {
        if (!deepEqual(nextProps.batchesByPurchaseOrder, this.props.batchesByPurchaseOrder)) {
            if (isArrayValidAndNotEmpty(nextProps.batchesByPurchaseOrder)) {
                this.initializeForm(nextProps.batchesByPurchaseOrder[0]);
            }
        }
    }

    componentWillUnmount() {
        this.props.dispatch(clearStockMoveByPurchaseOrderState());
    }

    onAddProductViaBarcode = async (productInfo, barcodeProductQty) => {
        console.log('asdas09du9asdu', productInfo, barcodeProductQty);
        const {
            dispatch,
            formValues,
        } = this.props;
        try {
            const indexToAddTo = getIndexToAdd(formValues, 'addStock');
            const rowValue = {};
            const response = await axios.get(`${API.PRODUCT.GET_PRODUCT_BY_CODE}${productInfo.produceCode}&codeField=${productInfo.codeField}&batchName=${productInfo.batchName}`);
            const product = response.data;
            rowValue.product = product;
            rowValue.uom = product.erpUomDto;
            rowValue.salePrice = null;
            rowValue.quantity = NumberOf(barcodeProductQty);
            rowValue.taxes = product.taxes || [];
            rowValue.expiry = productInfo.expiryDate;
            rowValue.description = productInfo.batchName;
            if (
                productInfo.codeField === PRODUCT_CODE_FIELD.EAN_13 &&
                isArrayValidAndNotEmpty(product.productGtinMapDtoList)
            ) {
                const matchingProductGtinMapDto = product.productGtinMapDtoList
                    .find(productGtinMapDto => productGtinMapDto.gtin === productInfo.produceCode);
                if (isObjectValidAndNotEmpty(matchingProductGtinMapDto)) {
                    rowValue.productGtinMapDto = matchingProductGtinMapDto;
                }
            }
            const newRowValue = extractAndSetValues(rowValue);
            this.props.change(`addStock[${indexToAddTo}]`, newRowValue);
        } catch (e) {
            apiCatchBlockFunction(e, dispatch);
        }
    };

    onPageChange = (page) => {
        this.setState({
            page,
        });
    };

    onSizeChange = (size) => {
        this.setState({
            size,
        });
    };

    getAllBatchesForPurchaseOrderInternal = () => {
        const {
            dispatch, targetId,
        } = this.props;
        let api = '';
        if (targetId) {
            api = `${API.STOCK.FETCH_STOCK_MOVES_BY_PICKING_ID}${targetId}`;
            dispatch(fetchStockMovesRequest(api));
        }
    };

    initializeForm = (formValues) => {
        const { dispatch, formValues: currentFormValues } = this.props;
        const mappedFormValues = mapAddStockDtoToUiObject(formValues);

        // Enrich rows with productId and uomCategoryId if they're missing
        // This preserves these fields needed for UOM search API
        if (isArrayValidAndNotEmpty(mappedFormValues.addStock) &&
            isArrayValidAndNotEmpty(currentFormValues && currentFormValues.addStock)) {
            mappedFormValues.addStock = mappedFormValues.addStock.map((row, index) => {
                if (row.product && row.product.uuid) {
                    // Try to find matching row in current form values by product UUID or sequence
                    const currentRow = currentFormValues.addStock.find(
                        r => (r.product && r.product.uuid === row.product.uuid) ||
                               (r.sequence === row.sequence && r.product && r.product.uuid),
                    ) || currentFormValues.addStock[index];

                    // Preserve productId and uomCategoryId from current form if they exist
                    if (currentRow) {
                        const productId = getStringFromObject('productId', row) ||
                            getStringFromObject('productId', currentRow) || 0;
                        // Try multiple sources for uomCategoryId - prioritize backend response, then current form, then from UOM category
                        const uomCategoryId = getStringFromObject('uomCategoryId', row) ||
                            getStringFromObject('uomCategoryId', currentRow) ||
                            getStringFromObject('uom.category.key', row) ||
                            getStringFromObject('uom.category.key', currentRow) ||
                            getStringFromObject('product.erpUomDto.category.key', row) ||
                            getStringFromObject('product.erpUomDto.category.key', currentRow) ||
                            0;

                        // Create a new row object to avoid mutating the parameter
                        // Preserve trackByBatch explicitly to ensure GTIN field editability is correct
                        const rowToProcess = {
                            ...row,
                            productId,
                            uomCategoryId,
                            // Explicitly preserve trackByBatch from mapper (set from productTrackByBatch)
                            trackByBatch: getStringFromObject('trackByBatch', row) !== undefined
                                ? getStringFromObject('trackByBatch', row)
                                : getStringFromObject('product.trackByBatch', row, false),
                            // Explicitly preserve productGtinMapDto from mapper to maintain correct GTIN selection
                            productGtinMapDto: getStringFromObject('productGtinMapDto', row) !== undefined
                                ? getStringFromObject('productGtinMapDto', row)
                                : null,
                            product: {
                                ...row.product,
                                productId: productId && productId !== 0 ? productId : row.product.productId,
                                erpUomDto: row.product.erpUomDto ? {
                                    ...row.product.erpUomDto,
                                    category: row.product.erpUomDto.category || (uomCategoryId && uomCategoryId !== 0 ? { key: uomCategoryId } : undefined),
                                } : row.product.erpUomDto,
                            },
                            uom: row.uom ? {
                                ...row.uom,
                                category: row.uom.category || (uomCategoryId && uomCategoryId !== 0 ? { key: uomCategoryId } : undefined),
                            } : row.uom,
                        };

                        // Preserve backend values to maintain consistency
                        const backendTotalCostPrice = rowToProcess.totalCostPrice;
                        const backendUom = rowToProcess.uom; // Preserve selected UOM from backend
                        const backendCostPerUom = rowToProcess.costPerUom; // This should already be from unitCost if available
                        const backendQuantity = rowToProcess.quantity; // This should already be uosQuantity if UOM != UOS
                        // CRITICAL: Preserve the base UOM (erpUomDto) from mapper - this is the product's actual base UOM
                        const backendErpUomDto = rowToProcess.product.erpUomDto; // This is the base UOM from mapper (productUom, not UOS)
                        // Preserve productGtinMapDto from backend to maintain correct GTIN selection
                        const backendProductGtinMapDto = rowToProcess.productGtinMapDto;

                        // Recalculate other values but preserve backend values to maintain rounding and UOM selection
                        // eslint-disable-next-line no-underscore-dangle
                        const tempRow = {
                            ...rowToProcess, _preserveTotalCostPrice: true, _preserveCostPerUom: true, _preserveQuantity: true,
                        };
                        const enrichedRow = extractAndSetValues(tempRow);

                        // CRITICAL: Restore the base UOM (erpUomDto) from mapper - it must remain the product's base UOM
                        // This is essential for correct conversion factor calculations
                        // Always restore it to ensure baseUomFactor is correct
                        if (backendErpUomDto && backendErpUomDto.uuid) {
                            // Preserve the entire erpUomDto object from mapper (base UOM)
                            enrichedRow.product.erpUomDto = cloneDeep(backendErpUomDto);
                        }

                        // Restore backend's values to preserve consistency and 5 decimal precision
                        // These values are already calculated correctly by backend
                        enrichedRow.totalCostPrice = NumberOf(backendTotalCostPrice); // Preserve as Number to maintain 5 decimal precision
                        enrichedRow.costPerUom = NumberOf(backendCostPerUom); // Preserve unitCost from backend with full precision
                        enrichedRow.quantity = NumberOf(backendQuantity); // Preserve uosQuantity if UOM != UOS
                        // Preserve the selected UOM (not the default/base UOM)
                        if (backendUom && backendUom.uuid) {
                            enrichedRow.uom = backendUom;
                        }
                        // Ensure productId and uomCategoryId are set
                        enrichedRow.productId = productId;
                        // Ensure uomCategoryId is preserved as a number (not 0 if it exists)
                        // Try multiple sources to ensure we don't lose it - check enrichedRow first (from extractAndSetValues)
                        const finalUomCategoryId = NumberOf(getStringFromObject('uomCategoryId', enrichedRow)) ||
                                                  NumberOf(uomCategoryId) ||
                                                  NumberOf(getStringFromObject('uom.category.key', enrichedRow)) ||
                                                  NumberOf(getStringFromObject('product.erpUomDto.category.key', enrichedRow)) ||
                                                  NumberOf(getStringFromObject('uom.category.key', row)) ||
                                                  NumberOf(getStringFromObject('product.erpUomDto.category.key', row)) ||
                                                  0;
                        enrichedRow.uomCategoryId = finalUomCategoryId;
                        // Also ensure it's set in the UOM object and product.erpUomDto for the search API
                        if (enrichedRow.uom && finalUomCategoryId !== 0) {
                            if (!enrichedRow.uom.category) {
                                enrichedRow.uom.category = { key: finalUomCategoryId };
                            } else if (!enrichedRow.uom.category.key || NumberOf(enrichedRow.uom.category.key) === 0) {
                                enrichedRow.uom.category.key = finalUomCategoryId;
                            }
                        }
                        // Ensure product.erpUomDto has category set (but preserve the base UOM structure)
                        // The erpUomDto should always be the product's base UOM from mapper, not the selected UOM
                        if (enrichedRow.product.erpUomDto && finalUomCategoryId !== 0) {
                            // Only update category if missing or invalid, don't overwrite the entire erpUomDto
                            if (!enrichedRow.product.erpUomDto.category) {
                                enrichedRow.product.erpUomDto.category = { key: finalUomCategoryId };
                            } else if (!enrichedRow.product.erpUomDto.category.key || NumberOf(enrichedRow.product.erpUomDto.category.key) === 0) {
                                enrichedRow.product.erpUomDto.category.key = finalUomCategoryId;
                            }
                            // Ensure the category key matches the preserved uomCategoryId
                            enrichedRow.product.erpUomDto.category.key = finalUomCategoryId;
                        }
                        // Preserve trackByBatch to ensure GTIN field editability is correct
                        // This is especially important for draft data where trackByBatch comes from backend
                        enrichedRow.trackByBatch = getStringFromObject('trackByBatch', rowToProcess) !== undefined
                            ? getStringFromObject('trackByBatch', rowToProcess)
                            : getStringFromObject('trackByBatch', enrichedRow, false);

                        // Preserve productGtinMapDto from backend to maintain correct GTIN selection
                        // This ensures the GTIN selected in each row matches what was saved
                        // Handle both null and undefined cases - null means no GTIN was selected, undefined means not set
                        if (backendProductGtinMapDto !== undefined) {
                            enrichedRow.productGtinMapDto = backendProductGtinMapDto;
                        } else if (getStringFromObject('productGtinMapDto', rowToProcess) !== undefined) {
                            enrichedRow.productGtinMapDto = getStringFromObject('productGtinMapDto', rowToProcess);
                        } else if (getStringFromObject('productGtinMapDto', enrichedRow) === undefined) {
                            // If not set anywhere, preserve from original row
                            enrichedRow.productGtinMapDto = getStringFromObject('productGtinMapDto', row) || null;
                        }

                        // Clear preservation flags so they don't interfere with future user changes
                        // eslint-disable-next-line no-underscore-dangle
                        delete enrichedRow._preserveTotalCostPrice;
                        // eslint-disable-next-line no-underscore-dangle
                        delete enrichedRow._preserveCostPerUom;
                        // eslint-disable-next-line no-underscore-dangle
                        delete enrichedRow._preserveQuantity;
                        return enrichedRow;
                    }

                    // If no matching row found, ensure productId and uomCategoryId are set
                    return {
                        ...row,
                        productId: getStringFromObject('productId', row) || 0,
                        uomCategoryId: getStringFromObject('uomCategoryId', row) || 0,
                    };
                }
                return row;
            });
        }

        dispatch(initialize(formName, mappedFormValues));
    };

    handleSave = (formValues) => {
        const { dispatch } = this.props;
        console.log('sdfsdfadsfasdfsdaf', formValues);
        const payload = mapAddStockFromUiObject(formValues, 'draft');
        dispatch(createAddStockRequest(payload));
    };

    handleConfirm = (formValues) => {
        const { dispatch, handleClose } = this.props;
        const payload = mapAddStockFromUiObject(formValues, 'done');
        dispatch(createAddStockRequest(payload, handleClose));
    };

    handleChooseGtin = (productGtinMapDto, _formName, field) => {
        const { formValues, dispatch } = this.props;
        const index = getIndexFromFieldName(field);
        if (formValues.addStock[index].productId) {
            if (isObjectValidAndNotEmpty(productGtinMapDto)) {
                if (productGtinMapDto.uuid && (typeof productGtinMapDto.uuid === 'string') && productGtinMapDto.uuid.includes('NCD-')) {
                    const gtin = extractTextFromDoubleQuotes(getStringFromObject('gtin', productGtinMapDto));
                    this.setState({
                        createNewGtin: true,
                        gtin,
                        index,
                    });
                }
            }
        } else {
            dispatch(errorMessage('You must select a product before adding Gtin'));
            this.clearGtin(index);
        }
    };


    handleCloseCreateDialog = (value) => {
        const {
            dispatch,
        } = this.props;
        const {
            index,
        } = this.state;
        dispatch(change(formName, `addStock[${index}].productGtinMapDto`, value));
        this.setState({
            createNewGtin: false,
            gtin: '',
        });
    }

    render() {
        const {
            open,
            handleClose,
            classes,
            handleSubmit,
            formValues,
            barcodeParser,
            dispatch,
        } = this.props;
        const {
            schema,
            page,
            size,
            createNewGtin,
            gtin,
            index,
        } = this.state;
        console.log('sjdlakjhdf', formValues);
        const isConfirmed = getStringFromObject('status', formValues) === 'done';
        const totalElements = getStringFromObject('addStock', formValues, []).length;
        const createdBy = getStringFromObject('createdBy', formValues);
        console.log('foradadamValues', createdBy);
        const allHandlers = {
            ...ACTION_HANDLERS,
            handleChooseGtin: this.handleChooseGtin,
        };
        return (
            <React.Fragment>
                <form>
                    <Dialog
                        open={open}
                        fullScreen
                        classes={{
                            paper: classes.paper,
                        }}
                        aria-labelledby="form-dialog-title"
                    >
                        <DialogTitle disableTypography id="form-dialog-title" className={classes.title}>
                            <Grid container justify="space-between">
                                <div className={classes.header}>
                                    Add Stock
                                </div>
                                <Close
                                    className={classNames(classes.closeIcon, 'cursor-pointer')}
                                    onClick={handleClose}
                                    test-id="stock-close"
                                />
                            </Grid>
                        </DialogTitle>
                        <DialogContent style={{ padding: '0' }}>
                            <div style={{ background: '#fff', padding: '1em 2em 2em' }}>
                                <Grid container spacing={16} justify="space-between">
                                    <Grid item container lg={6} md={6} sm={6}>
                                        <Grid item sm={6} style={{ padding: '1em' }}>
                                            <Field
                                                name="reference"
                                                testId="reference"
                                                component={OutlinedTextField}
                                                label="Reference Name"
                                                fullWidth
                                                required
                                                disabled={isConfirmed}
                                                InputProps={{
                                                    disableUnderline: true,
                                                    classes: {
                                                        root: classNames(classes.textField, classes.input),
                                                    },
                                                }}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                validate={[]}
                                            />
                                        </Grid>
                                        <Grid item container spacing={16} sm={12} style={{ padding: '1em' }}>
                                            <Grid item sm={6}>
                                                <Field
                                                    name="location"
                                                    testId="location"
                                                    component={ReduxFormReactSelectMaterial}
                                                    dataSourceConfig={{
                                                        text: 'name',
                                                        value: 'uuid',
                                                    }}
                                                    label="Location"
                                                    placeholder="Input Location"
                                                    isDisabled={isConfirmed}
                                                    selectProps={{
                                                        textFieldProps: {
                                                            InputProps: {
                                                                classes: {
                                                                    root: classes.reactSelectTextField,
                                                                    input: classes.selectInput,
                                                                },
                                                            },
                                                        },
                                                    }}
                                                    autocomplete
                                                    dataSourceApi={API.SEARCH.INTERNAL_STOCK_LOCATION}
                                                    validate={[required]}
                                                    required
                                                />
                                            </Grid>
                                            <Grid item sm={6}>
                                                <Field
                                                    testId="date"
                                                    label="Stock Date"
                                                    name="date"
                                                    component={DateInput}
                                                    fullWidth
                                                    disabled={isConfirmed}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    {
                                        createdBy &&
                                        <Grid item style={{ padding: '2em' }}>
                                            <Grid container>
                                                <SideLabelReadOnlyText
                                                    input={{ value: createdBy }}
                                                    label="Created by:"
                                                    classes={{
                                                        labelDiv: classes.labelDiv,
                                                    }}
                                                />
                                            </Grid>
                                        </Grid>
                                    }
                                </Grid>
                                {
                                    isObjectValidAndNotEmpty(formValues.location) && !isConfirmed &&
                                    <DrugBarcodeEntry
                                        dispatch={this.props.dispatch}
                                        onConfirmQuantity={this.onAddProductViaBarcode}
                                        barcodeParser={barcodeParser}
                                    />
                                }
                                <Grid container className="mt-2">
                                    {
                                        isObjectValidAndNotEmpty(schema) &&
                                        <ReduxFormMaterialTable
                                            fieldName="addStock"
                                            rowsPerPage={100}
                                            actionHandlers={allHandlers}
                                            dispatch={this.props.dispatch}
                                            styles={{ minHeight: '20em' }}
                                            rerenderOnEveryChange
                                            {...schema}
                                            tableRoot={{ minHeight: '20em', overflow: 'visible' }}
                                            isEditable={!isConfirmed}
                                            paramMap={formValues.addStock}
                                            formValues={formValues}
                                            internalPagination
                                            paginationDetails={{
                                                page,
                                                size,
                                                totalElements,
                                            }}
                                            handlePageChange={this.onPageChange}
                                            handleSizeChange={this.onSizeChange}
                                            enablePagination
                                            rowsPerPageOptions={[10, 20]}
                                        />
                                    }
                                </Grid>
                            </div>
                        </DialogContent>
                        <DialogActions style={{ padding: '12px' }}>
                            <ActionButton
                                testId="addstock-save"
                                disableRipple
                                disabled={isConfirmed}
                                onClick={handleSubmit(this.handleSave)}
                            >
                                Save
                            </ActionButton>
                            <ActionButton
                                testId="addstock-confirm"
                                disableRipple
                                disabled={isConfirmed}
                                onClick={handleSubmit(this.handleConfirm)}
                            >
                                Confirm
                            </ActionButton>
                        </DialogActions>
                    </Dialog>
                </form>
                {
                    createNewGtin &&
                    <GtinMapper
                        open
                        header={getStringFromObject('productName', formValues.addStock[index].product)}
                        product={formValues.addStock[index].product}
                        handleClose={this.handleCloseCreateDialog}
                        dispatch={dispatch}
                        gtin={gtin}
                    />
                }
            </React.Fragment>
        );
    }
}

AddStockDialog.propTypes = {
    classes: PropTypes.object.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    dispatch: PropTypes.func,
    change: PropTypes.func,
    handleClose: PropTypes.func.isRequired,
    formValues: PropTypes.object,
    open: PropTypes.bool.isRequired,
    batchesByPurchaseOrder: PropTypes.array,
    targetId: PropTypes.number,
    barcodeParser: PropTypes.string,
    appConfiguration: PropTypes.object,
};

AddStockDialog.defaultProps = {
    dispatch: () => {},
    change: () => {},
    formValues: { expiry: getDateInYYYYMMDDFormat(new Date()) },
    batchesByPurchaseOrder: [],
    targetId: null,
    barcodeParser: '',
    appConfiguration: {},
};

const mapStateToProps = state => ({
    formValues: state.form[formName] ? state.form[formName].values : {},
    batchesByPurchaseOrder: state.stockMove.stockMovesByPurchaseOrder,
    barcodeParser: getStringFromObject('appConfiguration.barcodeParser', state),
    appConfiguration: state.appConfiguration,
});

export default connect(mapStateToProps)(reduxForm({
    form: formName,
    initialValues: cloneDeep(UI_OBJECT),
})(withStyles(dialogComponentStyles)(AddStockDialog)));
